(function() {
	document.addEventListener( 'DOMContentLoaded', () => {
		// Yotpo
		const yotpoCarousels = document.querySelectorAll( '.yotpo-reviews-carousel' );
		
		if ( yotpoCarousels.length > 0 ) {
			const yotpoInterval = setInterval( () => {
				if ( typeof( yotpo ) !== 'undefined' ) {
					let readMoreToolTips = document.querySelectorAll( '.yotpo .carousel-tool-tip' );
					
					if ( readMoreToolTips.length > 0 ) {
						clearInterval( yotpoInterval );
						readMoreToolTips.forEach( (tt) => {
							tt.setAttribute( 'aria-label', 'Review Content' );
						});
					}
				}
			}, 500 );
		}
		
		// Klaviyo
		const klaviyoFooterForm = document.querySelector( '.klaviyo-form-WsNnAu' );
		
		if ( klaviyoFooterForm != null ) {
			const klaviyoFooterInterval = setInterval( () => {
				let klaviyoEmailField = document.querySelector( '.klaviyo-form-WsNnAu input[name="email"]' );
				
				if ( klaviyoEmailField != null ) {
					clearInterval( klaviyoFooterInterval );
					klaviyoEmailField.setAttribute( 'aria-required', 'true' );
				}
			}, 500 );
		}
	});
	
	document.addEventListener( 'mouseover', (e) => {
		const el = e.target.closest( '.tmenu_item--root.tmenu_item_has_child:not(.tmenu_item_active)' );
		
		if ( el != null ) {
			const targetEl = el.querySelector( '.tmenu_item_link' );
			targetEl.dispatchEvent( new Event( 'click' ) );
			
			if ( el.dataset.mouseleaveAdded != true && el.dataset.mouseleaveAdded != 'true' ) {
				el.addEventListener( 'mouseleave', (e) => {
					targetEl.dispatchEvent( new Event( 'click' ) );
				});
				
				el.dataset.mouseleaveAdded = true;
			}
		}
	});
})();